/**
 * jQuery setup.
 * 
 * This needs to run in highest priority (not within DOM ready or async)
 */
import specialEventIsLoaded from './jquery/special-event-isloaded';
import ariaVisibilityPlugins from './jquery/aria-toggle';

// plugins
import './jquery/save-form';

export default () => {
  // setup 'isloaded' (for window only) special event
  specialEventIsLoaded();
  ariaVisibilityPlugins();
};